document.addEventListener("DOMContentLoaded", function() {
    // Ottieni i dati del carrello
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            // Filtra i prodotti "Compendi per concorsi"
            let compendi = cart.items.filter(item => item.product_type === "compendi per concorsi");

            // Se ci sono almeno 3 compendi
            if (compendi.length >= 3) {
                // Ordina i compendi per prezzo (dal più economico al più costoso)
                compendi.sort((a, b) => a.final_line_price - b.final_line_price);

                // Controlla se il terzo prodotto è abbastanza economico
                let thirdItem = compendi[2];
                let secondItem = compendi[1];
                let cheapestItem = compendi[0];

                // Se il terzo prodotto è più economico di uno degli altri due, mostra il messaggio di sconto
                if (thirdItem.final_line_price <= secondItem.final_line_price || thirdItem.final_line_price <= cheapestItem.final_line_price) {
                    // Mostra un messaggio di promozione
                    alert("Hai diritto al 50% di sconto sul terzo compendio, se è il più economico! Usa il codice BUNDLE50 al checkout.");
                }
            }
        })
        .catch(error => {
            console.error("Errore durante il recupero del carrello:", error);
        });
});
